import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../api/client";

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      return api<{ ok: boolean }>("/auth/logout", { method: "POST" });
    },
    onSuccess: () => {
      qc.setQueryData(["auth", "me"], null);
      qc.invalidateQueries({ queryKey: ["auth", "me"] });
    },
  });
}
